import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const resetPasswordAPI = createApi({
    reducerPath: "resetPasswordAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        addResetPass: builder.mutation({
            query: (data) => ({
                url: "/User/ChangePassword",
                method: "POST",
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        resendEmailUserPassword: builder.mutation({
            query: (data) => ({
                url: "/User/ResendEmailUserPassword",
                method: "POST",
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        userTempResetPassword: builder.mutation({
            query: (data) => ({
                url: "/User/UserTempResetPassword",
                method: "POST",
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const {
    useAddResetPassMutation,
    useResendEmailUserPasswordMutation,
    useUserTempResetPasswordMutation, 
} = resetPasswordAPI;

export default resetPasswordAPI;
